import Page from '@/global/util/Page'
const TRANSFER_EVENT_TABLE_DATA = 'TRANSFER_EVENT_TABLE_DATA' // 事件转化率列表
const GLOBAL_ALL_AD_SELECT = 'GLOBAL_ALL_AD_SELECT' // 全局所有广告
const GLOBAL_ALL_CREATIVE_SELECT = 'GLOBAL_ALL_CREATIVE_SELECT' // 全局所有创意
const TRANSFER_EVENT_SELECT='TRANSFER_EVENT_SELECT' // 事件下拉菜单
export function createModule (platform, { capturedGet, capturedPost, capturedPut, capturedRemove } = {}) {
const state = {
  transferEvent: {
    page: new Page(),
    search: {
      advertiser_id: [],
      ad_id: [],
      creative_id: [],
      event_type: [],
      dimensions: ['date_time', 'advertiser_id', 'ad_id', 'creative_id', 'event_type']
    }
  },
  globalAllAdSelect: [],
  globalAllCreativeSelect: [],
  transferEventSelect: [],
  dimensionsSelect: [
    { name: '时间', value: 'date_time' },
    { name: '广告主', value: 'advertiser_id' },
    { name: '计划', value: 'ad_id' },
    { name: '创意', value: 'creative_id' },
    { name: '事件', value: 'event_type' }
  ],
  dimensionsDataSelect: [
    { name: '时间', value: 'date_time' },
    { name: '广告主', value: 'advertiser_id' },
    { name: '广告组', value: 'order_id' },
    { name: '计划', value: 'ad_id' },
    { name: '创意', value: 'creative_id' }
  ],
}
const getters = {
  transferEvent: state => state.transferEvent
}
const actions = {
  async getALLAdSelect({ state, commit},  { platform, params } = {}) {
    let [,result] = await capturedGet(`${platform}/global/ads/all-ad`, { params })
    commit(GLOBAL_ALL_AD_SELECT, { result: result.data })
  },
  async getALLCreativeSelect({ state, commit},  { platform, params } ={}) {
    let [,result] = await capturedGet(`${platform}/creative/all-creative`, { params })
    commit(GLOBAL_ALL_CREATIVE_SELECT, { result: result.data })
  },
  async getTransferEventSelect({ state, commit},  { platform, params } ={}) {
    let [,result] = await capturedGet(`interface/etcd/jsonitem/transformation_event`, { params })
    commit(TRANSFER_EVENT_SELECT, { result: result.data })
  },
  async getListData(
    { state, commit },
    { platform, params, page = state.transferEvent.page.currentPage, pageSize = state.transferEvent.page.pageSize } = {}
  ) {
    let [,result] = await capturedGet(`transformation/list`, { ...params, page, pageSize })
    commit(TRANSFER_EVENT_TABLE_DATA, { result: result.data })
  }
}
const mutations = {
  [GLOBAL_ALL_AD_SELECT](state, { result }) {
    state.globalAllAdSelect = result
    console.log(state)
  },
  [GLOBAL_ALL_CREATIVE_SELECT](state, { result }) {
    state.globalAllCreativeSelect = result
  },
  [TRANSFER_EVENT_SELECT](state, { result }) {
    state.transferEventSelect = result
  },
  [TRANSFER_EVENT_TABLE_DATA](state, { result }) {
    state.transferEvent.page.setPageData(
      {
        header: result.header,
        data: result.data,
        total: result.total
      },
      false
    )
  }
}
  return {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
}
